import { Courses } from "../courses"
import { Reports } from "../reports"

export const WorkforceReports = ({pageSwap }) =>  {
    return(
        <Reports 
            titleScreen = "Workforce reports"
            CustomerStage={5}
       />
    )
}